import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useCan } from '../utils/perms';

export default function PermissionGate({ module, action = 'view', children }) {
  const can = useCan(module, action);
  const navigate = useNavigate();
  if (can) return children;
  return (
    <Result
      status="403"
      title="403"
      subTitle={`You don't have permission to ${action} this module.`}
      extra={<Button type="primary" onClick={() => navigate('/')}>Back to Dashboard</Button>}
    />
  );
}
